import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { t } = useTranslation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    // Clean hash immediately
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/api/auth/emergent/session", { session_id: sessionId });
        await refresh();
        toast.success(t("auth_callback.toast_success"));
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error(t("auth_callback.toast_failed"));
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh, t]);

  return (
    <div className="min-h-screen flex items-center justify-center marketing-shell">
      <div className="text-white/70">{t("auth_callback.loading")}</div>
    </div>
  );
}
